module.exports = __webpack_public_path__ + "img/christina-coleman.b33f53bb.jpg";